import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20h16","key":"svg-0"}],["path",{"d":"M4 12h16","key":"svg-1"}],["path",{"d":"M4 4h16","key":"svg-2"}]]

const IconBaselineDensityMedium = createReactComponent('outline', 'baseline-density-medium', 'BaselineDensityMedium', __iconNode);

export default IconBaselineDensityMedium;